<template>
  <q-page fluid>
    <div v-if="currentStatus.StrStatusType == 'Error'" class="ErrorBanner">
      <div class="row">
        <div class="col-12">Error</div>
        <div class="col-12">
          {{ currentStatus.StrStatusMessage }}
        </div>
      </div>
    </div>
    <div v-if="currentStatus.StrStatusType == 'Warning'" class="WarningBanner">
      <div class="row">
        <div class="col-12">Warning</div>
        <div class="col-12">
          {{ currentStatus.StrStatusMessage }}
        </div>
      </div>
    </div>
    <div v-if="over20MinutesWarning" class="fullScreenWarning">
      <div class="centerMiddleScreen">
        <div v-if="reCalibrationStage == 'Stop Scan'">
          <h6
            class="q-mb-lg text-white pwa-heading"
            style="max-width: 370px; font-size: 22pt !important"
          >
            Calibration Required
          </h6>
          <h6
            class="q-mt-none text-white pwa-heading"
            style="max-width: 370px; font-size: 16pt !important"
          >
            Please Stop the Vehicle <br />
            Then stop the scan <br />
          </h6>

          <br />
          <q-btn @click="pauseScan" class="q-mt-sm" color="white" outline>
            Stop Scan
          </q-btn>
        </div>
        <div v-if="reCalibrationStage == 'Re Calibrate'">
          <h6
            class="q-mb-lg text-white pwa-heading"
            style="max-width: 370px; font-size: 22pt !important"
          >
            Calibration Required
          </h6>
          <h6
            class="q-mt-none text-white pwa-heading"
            style="max-width: 370px; font-size: 16pt !important"
          >
            Please Calibrate <br />
          </h6>

          <br />
          <q-btn
            @click="reCalibrateDevice"
            class="q-mt-sm"
            color="white"
            outline
          >
            Calibrate Device
          </q-btn>
          <br />
          <q-btn @click="stopScan" class="q-mt-sm" color="white" outline>
            Stop Scan
          </q-btn>
        </div>
        <div v-if="reCalibrationStage == 'Continue Scan'">
          <h6
            class="q-mb-lg text-white pwa-heading"
            style="max-width: 370px; font-size: 22pt !important"
          >
            Calibrated
          </h6>

          <br />
          <q-btn @click="continueScan" class="q-mt-sm" color="white" outline>
            Continue Scan
          </q-btn>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <audio
      ref="audio"
      src="/statics/notification.mp3"
      preload
      id="audio"
      muted
      paused
    ></audio>
    <div class="toggle-sound"></div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { QSpinnerGears } from "quasar";

export default {
  components: {},
  computed: {
    ...mapGetters([
      "currentUser",
      "currentSurvey",
      "currentPHPID",
      "currentStatus",
      "over20MinutesWarning",
    ]),
  },
  props: {
    source: String,
  },
  watch: {
    over20MinuteWarning: function () {
      if (this.over20MinutesWarning == true) {
        this.toggleSoundAndVibration();
      }
    },
  },
  data: () => ({
    reCalibrationStage: "Stop Scan",
    musicStarted: false,
    musicPlaying: false,
  }),
  mounted() {
    setInterval(() => {
      if (
        window.location.host == "192.168.4.100" ||
        window.location.host == "tdri.local"
      ) {
        this.$store.dispatch("deviceStatusRequest");
      }
    }, 5000);
    // this.toggleSoundAndVibration();
  },
  methods: {
    toggleSoundAndVibration() {
      navigator.vibrate(1000);
      // let audio = this.$refs.audio;
      // if (this.musicPlaying == false) {
      //   audio.volume = 0.5;
      //   audio.play();
      //   document.querySelector(".toggle-sound").classList.remove("paused");
      //   this.musicStarted = true;
      //   this.musicPlaying = true;
      // } else {
      //   if (
      //     audio.paused &&
      //     document.querySelector(".toggle-sound").classList.contains("paused")
      //   ) {
      //     // console.log("play it");
      //     audio.volume = 0.5;
      //     audio.play();
      //     document.querySelector(".toggle-sound").classList.remove("paused");
      //     this.musicPlaying = true;
      //   } else {
      //     // console.log("pause it");
      //     audio.pause();
      //     document.querySelector(".toggle-sound").classList.add("paused");
      //     this.musicPlaying = false;
      //   }
      // }
    },
    pauseScan() {
      // let audio = this.$refs.audio;
      // audio.pause();
      // document.querySelector(".toggle-sound").classList.add("paused");
      // this.musicPlaying = false;
      this.$q.loading.show({
        message: "Stopping Scan",
        spinner: QSpinnerGears,
      });
      this.$store
        .dispatch("runDeviceCommand", {
          ep: "device/StopRecording",
          command: "StopRecording",
          payload: {},
        })
        .then((res) => {
          this.$q.loading.hide();
          if (res == "Success") {
            this.reCalibrationStage = "Re Calibrate";
          } else {
            this.$swal({
              title: "Error",
              text: "There was an issue communication with the Device, Please try again",
              type: "warning",
              confirmButtonText: "Retry",
              confirmButtonColor: "#3284E3",
            }).then((res) => {
              if (res.value) {
                this.pauseScan();
              }
            });
          }
        });
    },
    stopScan() {
      this.reCalibrationStage = "Stop Scan";
      this.$store.dispatch("resetDeviceScanStartTime");
      this.$store.dispatch("scanStoppedExternal", true);
      // this.$router.push("/mobile-view/mp-survey");
    },
    reCalibrateDevice() {
      this.$q.loading.show({
        message: "Calibrating Please do not close the app",
        spinner: QSpinnerGears,
      });
      this.$store.dispatch("calibrateDevice").then((res) => {
        this.$q.loading.hide();
        // If the calibration hit the 1 minute timeout
        if (!res) {
          this.$swal({
            title: "Error",
            text: "There was an issue Calibrating the Device, Please try again",
            type: "warning",
            confirmButtonText: "Retry",
            confirmButtonColor: "#3284E3",
          }).then((res) => {
            if (res.value) {
              this.$q.loading.show({
                message: "Calibrating Please do not close the app",
                spinner: QSpinnerGears,
              });

              this.$store.dispatch("calibrateDevice").then((res2) => {
                this.$q.loading.hide();
                // If the calibration hit the 1 minute timeout Again
                if (!res2) {
                  this.$swal({
                    title: "Error",
                    text: "There was an issue Calibrating the Device Again, Please contact tech support to solve this issue.",
                    type: "warning",
                    confirmButtonText: "Retry",
                    confirmButtonColor: "#3284E3",
                  });
                } else {
                  this.reCalibrationStage = "Continue Scan";
                }
              });
            }
          });
        } else {
          this.reCalibrationStage = "Continue Scan";
        }
      });
    },
    continueScan() {
      let data = JSON.parse(JSON.stringify(this.currentSurvey));
      data.phpID = this.currentPHPID;
      this.$store
        .dispatch("runDeviceCommand", {
          ep: "device/ContinueRecording",
          command: "ContinueRecording",
          payload: data,
        })
        .then((res) => {
          if (res == "Success") {
            this.$store.dispatch("setDeviceScanStartTime");
            this.reCalibrationStage = "Stop Scan";
          } else {
            this.$swal({
              title: "Error",
              text: "There was an issue communication with the Device, Please try again",
              type: "warning",
              confirmButtonText: "Retry",
              confirmButtonColor: "#3284E3",
            }).then((res) => {
              if (res.value) {
                this.continueScan();
              }
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.ErrorBanner {
  background: $negative;
  color: white;
  position: relative;
  width: 70%;
  margin: auto;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
}

.WarningBanner {
  background: $warning;
  color: white;
  position: relative;
  width: 70%;
  margin: auto;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
}

.fullScreenWarning {
  background: $negative;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.centerMiddleScreen {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 350px;
}
</style>
